var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#EAFAF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0139 31C48.0139 38.1875 40.8264 44 32.0139 44C29.6389 44 27.4514 43.625 25.4514 42.9375C24.7639 43.4375 23.5139 44.1875 22.0764 44.8125C20.5764 45.5 18.7639 46 17.0139 46C16.5764 46 16.2014 45.8125 16.0764 45.4375C15.8889 45.0625 16.0139 44.625 16.2639 44.3125C16.3264 44.3125 16.3264 44.25 16.3889 44.1875C16.4514 44.125 16.5764 44 16.7014 43.875C16.9514 43.5625 17.2639 43.0625 17.6389 42.5C18.2639 41.5 18.8264 40.125 18.9514 38.5625C17.0764 36.4375 16.0139 33.875 16.0139 31C16.0139 23.875 23.1389 18 32.0139 18C40.8264 18 48.0139 23.875 48.0139 31Z",
    fill: "#2FB273"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.82e33075903d84ef0c04e3cc866afbad.svg";
export { ForwardRef as ReactComponent };